import { MISSION_PROVIDER_LABELS } from "../constants/missionRequirementProviders.constant";

export class MissionProvidersTransformer {
  static humanizeProviderKlass(klass?: string) {
    if (!klass) return undefined;
    if (MISSION_PROVIDER_LABELS[klass]) return MISSION_PROVIDER_LABELS[klass];

    const raw = klass.split("::").pop() || klass;
    const withSpaces = raw.replace(/([A-Z])/g, " $1").trim();

    return withSpaces.length ? withSpaces : raw;
  }
}

export default MissionProvidersTransformer;
